import React, { useMemo, useState } from 'react'
import './FyOpeningBalance.css'
import { Edit, Plus } from 'lucide-react'

const FyOpeningBalance = () => {

    const [searchQuery, setSearchQuery] = useState("");
    const [currentPage, setCurrentPage] = useState(1);
    const [itemsPerPage, setItemsPerPage] = useState(1);
    const ITEMS_PER_PAGE_OPTIONS = [1, 2, 4];

const data = [
  {
    financialYear: "2020",
    branch: "A",
    ledger: "FD",
    group:"Group a",
    OpeningBalance:"2000"
  },
  {
    financialYear: "2026",
    branch: "A",
    ledger: "FD",
    group:"Group a",
    OpeningBalance:"2000"
  },

];

  
    // Search + Pagination
    const filteredData = useMemo(() => {
      return data.filter((item) =>
        Object.values(item).join(" ").toLowerCase().includes(searchQuery.toLowerCase())
      );
    }, [data, searchQuery]);
  
    const totalPages = Math.ceil(filteredData.length / itemsPerPage);
  
    const paginatedData = filteredData.slice(
      (currentPage - 1) * itemsPerPage,
      currentPage * itemsPerPage
    );
  
    const handleItemsPerPageChange = (e) => {
      setItemsPerPage(Number(e.target.value));
      setCurrentPage(1);
    };
  return (
    <>
      <div className="fyOpening-balance-container">
      {/* Page Title */}
      <h1 className="fyOpening-balance-title">FY Opening Balance</h1>

      {/* Filter Section */}
      <div className="fyOpening-balance-filterBox">
        <div className="fyOpening-balance-filter-title">Filter By</div>
        <div className="fyopening-filter-item-container">
          <div className="fyopening-filter-item-div">
          <div className="fyopening-filter-item">
            <label>Session</label>
            <select>
              <option value=""></option>
            </select>
          </div>
          <div className="fyopening-filter-item">
            <label>Branch</label>
            <select>
              <option value="">Select Branch</option>
              <option value="Bareilly">Bareilly</option>
              <option value="Delhi">Delhi</option>
              <option value="Mumbai">Mumbai</option>
            </select>
          </div>
          </div>
          <div className="">
          <button className="fyopening-filter-btn">Get Records</button>
          </div>
        </div>
      </div>

      {/* Reports */}
       <div className="fyOpening-balance-report-section">
          <div className="fyOpening-balance-report-top">
            <h2>FY Opening Balance</h2>
            <button><Plus size={15}/></button>
          </div>
          <div className="fyOpening-balance-report-filter">
             <input
              type="text"
              placeholder="Search..."
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
            />

            <div className="fyOpening-balance-filter">
              <label>Show </label>
              <select onChange={handleItemsPerPageChange} value={itemsPerPage}>
                {ITEMS_PER_PAGE_OPTIONS.map((num) => (
                  <option key={num} value={num}>{num}</option>
                ))}
              </select>
              <span> entries</span>
            </div>
          </div>

          <div className="fyOpening-balance-report-table">
            <table>
              <thead>
                <tr>
                  <th>Sr.No.</th>
                  <th>Financial Year</th>
                  <th>Branch</th>
                  <th>Ledger</th>
                  <th>Group</th>
                  <th>Opening Balance</th>
                  <th>Action</th>
                </tr>
              </thead>

              <tbody>
                {/* Row Sample */}
               {paginatedData.length > 0 ? (
                  paginatedData.map((item, index) => (
                    <tr key={item.id}>
                      <td>{(currentPage - 1) * itemsPerPage + index + 1}</td>
                      <td>{item.financialYear}</td>
                      <td>{item.branch}</td>
                      <td>{item.ledger}</td>
                      <td>{item.group}</td>
                      <td>{item.OpeningBalance}</td>
                      <td><Edit size={15}/></td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="7" style={{ textAlign: "center" }}>No results found</td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>

          {filteredData.length > itemsPerPage && (
            <div className="fyOpening-pagination-div">
              <button disabled={currentPage === 1} onClick={() => setCurrentPage(currentPage - 1)}>
                ⬅ Prev
              </button>

              <span> Page {currentPage} of {totalPages} </span>

              <button disabled={currentPage === totalPages} onClick={() => setCurrentPage(currentPage + 1)}>
                Next ➡
              </button>
            </div>
          )}
        </div>
    </div>
    </>
  )
}

export default FyOpeningBalance
